import React, { useEffect, useState, useRef } from 'react'
import Barcode from "react-barcode";
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

import styles from "./BarcodeLabels.module.sass"
import { BARCODE_LOCAL_STORAGE_KEY } from '../../constants';

const BarcodePrint = () => {
  const [barcodes, setBarcodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const componentRef = useRef();
  const chunkedBarcodesRef = useRef([]);


  // Split barcodes into groups of 2
  const chunkedBarcodes = [];
  for (let i = 0; i < barcodes.length; i += 2) {
    chunkedBarcodes.push(barcodes.slice(i, i + 2));
  }


  const convertHtmlToImage = async (elementRefs) => {
    const images = [];

    for (let i = 0; i < elementRefs.length; i++) {
      const canvas = await html2canvas(elementRefs[i], {
        scale: 2,
      });

      const image = canvas.toDataURL("image/png");

      images.push(image);
    }

    return images;
  }

  const handlePrintPDF = async () => {
    setLoading(true);
    const pdf = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: [100, 25]
    })

    const images = await convertHtmlToImage(chunkedBarcodesRef.current);

    images.forEach((image, index) => {
      pdf.addImage(image, 'PNG', 0, 0, 100, 25);

      if (index !== images.length - 1) {
        pdf.addPage();
      }
    })
    pdf.save('barcodes.pdf');
    setLoading(false);
  }

  useEffect(() => {
    const barcodesInLocalStorage = JSON.parse(localStorage.getItem(BARCODE_LOCAL_STORAGE_KEY));
    if (barcodesInLocalStorage) {
      setBarcodes(barcodesInLocalStorage);
    }
  }, []);
  return (
    barcodes.length > 0 ? (
      <div>
        {
          loading && <h1>Generating PDF...</h1>
        }
        <div className={styles.labelsContainer} ref={componentRef}>
          {chunkedBarcodes.map((pair, rowIndex) => (
            <div className={styles.row} key={rowIndex} ref={(el) => chunkedBarcodesRef.current[rowIndex] = el}>
              {pair.map((code, colIndex) => (
                <div className={styles.sticker} key={colIndex}>
                  <div className={styles.barcodeInner}>
                    <Barcode
                      value={code}
                      width={1}
                      height={50}
                      displayValue
                      fontSize={12}
                    />
                  </div>
                </div>
              ))}

              {/* If only 1 barcode in this chunk, render an empty sticker to maintain layout */}
              {pair.length === 1 && <div className={styles.sticker} />}
            </div>
          ))}
        </div>

        <button onClick={handlePrintPDF} style={{ marginTop: 20 }}>
          Print Labels
        </button>
      </div>
    ) : (<p>No barcodes to print</p>)
  )
}

export default BarcodePrint